/**
 * Utility to determine if an `HTMLElement`
 * is partially visible in viewport.
 *
 * @param {HTMLElement} element target
 * @return {boolean} Boolean
 */
export default function isElementInScrollRange(element) {
  const bcr = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  return bcr.top <= viewportHeight && bcr.bottom >= 0; // bottom && top
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/misc/isElementInScrollRange.js
// module id = 17
// module chunks = 0